import { Box, Tooltip } from '@mui/material';
import { fDateTime, fMonthDayYear } from '../../utils/formatTime';
import Iconify from '../iconify';

const renderIcon = (value, icon) => (
  <Box>
    <Iconify icon={icon} width={13} height={13} /> {value}
  </Box>
);

const facility = { field: 'facility', headerName: 'Facility', minWidth: 90, flex: 1.5, type: 'customSelect' };
const company = { field: 'company', headerName: 'Group', minWidth: 90, flex: 1, type: 'customSelect' };
const beds = { field: 'beds', headerName: 'Bed Count', minWidth: 90};
const average = {
  field: 'average',
  headerName: 'Average',
  width: 100,
  renderCell: (params) => Math.ceil(params.value),
};
const current = { field: 'current', headerName: 'Current', width: 100 };
const budgetDayCount = { field: 'budgetDayCount', headerName: 'Budget Day Count', width: 150 };
const censusTotal = { field: 'censusTotal', headerName: 'Census Total', width: 120 };

const addedBy = {
  field: 'addedBy',
  headerName: 'Inserted By',
  flex: 1,
  renderCell: (params) => `${params.row.addedBy}`,
};

const censusInputType = {
  field: 'censusInputType',
  headerName: 'Type',
  minWidth: 90,
  flex: 1,
  renderCell: (params) =>
    <Tooltip
      arrow
      title={`Last updated ${fDateTime(params.row.dateModified)}`}
      disableHoverListener={params.row.censusInputType !== 'Manual'}
    >
      <span>{params.value}</span>
    </Tooltip>,
};

const date = {
  field: 'date',
  headerName: 'Date',
  flex: 0.5,
  renderCell: (params) => renderIcon(fMonthDayYear(params.value), 'material-symbols:calendar-today-outline'),
};

const FULL_CENSUS_COLUMNS = [facility, company, beds, current, average, budgetDayCount, censusTotal, censusInputType];

const FACILITY_CENSUS_COLUMNS = [facility, addedBy, censusInputType, date];

export { FULL_CENSUS_COLUMNS, FACILITY_CENSUS_COLUMNS };
